import type { InferOutput } from 'valibot'
import { SolrParamsKey } from '#shared/solr'
import { array, intersect, literal, nullish, object, string } from 'valibot'
import { authorSchema } from '~/utils/solr/author'
import { baseBodySchema } from '~/utils/solr/body'
import { headersSchema } from '~/utils/solr/headers'

export const solrAuthorsResponseSchema = object({
  responseHeader: headersSchema,
  response: intersect([
    baseBodySchema,
    object({
      docs: array(authorSchema),
    }),
  ]),
})

export type SolrAuthorsResponseSchema = InferOutput<typeof solrAuthorsResponseSchema>

export const authorsSchema = object({
  nodeType: literal('author'),
  filter: nullish(string()),
  remoteIds: nullish(array(string())),
  ezObjectIds: nullish(array(string())),
  sort: nullish(string()),
})

export type Authors = InferOutput<typeof authorsSchema>

export const authorParamsSchema = object({
  [SolrParamsKey.Author]: nullish(string()),
  [SolrParamsKey.Authors]: nullish(authorsSchema),
})

export type AuthorParams = InferOutput<typeof authorParamsSchema>

interface UseAuthorQueryOptions {
  enabled?: MaybeRefOrGetter<boolean>
}
export function useAuthorQuery(params: MaybeRef<AuthorParams>, options?: UseAuthorQueryOptions) {
  const queryOptions = useSolrQueryOptions({
    endpoint: 'authors',
    params,
    schema: solrAuthorsResponseSchema,
    enabled: (p) => {
      const hasParams = Object.values(p ?? {}).some(
        value => value !== undefined && value !== null,
      )

      const externallyEnabled = options?.enabled === undefined
        ? true
        : toValue(options.enabled)

      return hasParams && externallyEnabled
    },
  })

  return useQuery(queryOptions)
}
